import { UserPointRankingEntry } from 'models/ranking/pointRanking/entry/UserPointRankingEntry';

export class UserPointRankingEntryService {
	toModel(ranking) {
		return new UserPointRankingEntry(ranking);
	}
}
